import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Fargo, North Dakota?",
    a: "Fargo residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Chicago, 570+ miles away — our service eliminates that trip entirely.",
  },
  {
    q: "Where is the nearest passport agency to Fargo, ND?",
    a: "The Chicago Regional Passport Agency (230 S. Dearborn St, Chicago, IL) is approximately 570+ miles from Fargo. It requires an appointment and is for genuine life-or-death emergencies only. Fast Passport Center provides the same expedited processing without requiring you to travel.",
  },
  {
    q: "How long does passport processing take from Fargo?",
    a: "With Fast Passport Center, 2–9 days. Standard post office expedited processing takes 3–5 weeks, and routine processing takes 6–11 weeks. Given Fargo's distance from regional agencies, our courier service is the fastest practical option for most travelers.",
  },
  {
    q: "Which post offices in Fargo accept passport applications?",
    a: "The Fargo Main Post Office (657 2nd Ave N), West Fargo Post Office (720 13th Ave E), and the Cass County Clerk of Courts all accept passport applications. Fast Passport Center will tell you exactly which facility to use and what documents to bring.",
  },
  {
    q: "Can West Fargo and Moorhead residents use your service?",
    a: "Absolutely. Fast Passport Center serves the entire Fargo metro area including West Fargo, Moorhead MN, Dilworth MN, Harwood, Horace, Casselton, and all surrounding communities. Your location in the metro doesn't affect our ability to help.",
  },
  {
    q: "Do I need to travel to Chicago for an emergency passport from Fargo?",
    a: "Only if you have a documented life-or-death emergency AND travel within 72 hours. For all other urgent situations — including trips within 2–3 weeks — Fast Passport Center provides expedited processing without requiring a 570-mile drive to Chicago.",
  },
  {
    q: "How much does expedited passport service cost in Fargo?",
    a: "The government fee is $60 for expedited renewal ($130 for new passports) plus a $35 execution fee if submitting in person. Fast Passport Center charges an additional service fee for our courier and agent services. Contact us for a full quote based on your specific situation.",
  },
  {
    q: "Can I get a child passport expedited in Fargo?",
    a: "Yes. Minors under 16 require in-person application with both parents (or documented absent-parent consent). Fast Passport Center prepares all required forms including DS-11 and DS-3053, and guides Fargo families through every parental requirement.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fargo Passport Questions Answered
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything Fargo and Cass County residents need to know about expedited passport services.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <span className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${openIndex === i ? "ri-subtract-line" : "ri-add-line"} text-[#F6C344] text-lg`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 text-sm text-gray-500 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: { "@type": "Answer", text: faq.a },
            })),
          }),
        }}
      />
    </section>
  );
}